import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createOpcionPedagogicaSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
});
